import React from 'react';
import { WithApp } from 'contexts/appContext';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Edit, Visibility, Map } from '@material-ui/icons';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Link } from 'react-router-dom';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Código SN', accessor: 'CardCode', width: 150 },
  { Header: 'Socio Negocio', accessor: 'CardName' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Dirección fiscal', accessor: 'billAddress' },
  { Header: '', accessor: 'stateImg', width: 50, excelEnabled: false },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: 'Latitud', accessor: 'latitude', width: 150 },
  { Header: 'Longitud', accessor: 'longitude', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function DialogDirecciones(props) {
  const {
    classes,
    eventClose,
    open,
    selectedBureau,
    addresses,
    setShowModalAddress,
    setObjAddress,
    setOpenInfo,
    setInfoData,
  } = props;

  return (
    <Dialog onClose={eventClose} open={open} maxWidth="xl">
      <DialogTitle onClose={eventClose}>
        Listado de direcciones
        <br />
        {selectedBureau == undefined ? (
          <small
            style={{
              fontSize: '15px',
            }}
          >
            Sin filtro de mesa
          </small>
        ) : (
          <small
            style={{
              fontSize: '15px',
            }}
          >
            Filtro: {selectedBureau.description}
          </small>
        )}
        <IconButton aria-label="close" className={classes.closeButton} onClick={eventClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <ReactTable
          excelName="Listado-de-direcciones"
          pagination={false}
          fullPagination={true}
          defaultWidth={1000}
          columns={columns}
          data={addresses.map((item, i) => {
            return {
              num: (
                <div className="actions-right">
                  {i + 1}
                  <Link
                    to={`/admin/socio-negocio/datos-maestros/clientes/${item.base_business_partner_id}#direcciones`}
                    target="__blank"
                  >
                    <Visibility />
                  </Link>
                  {item.latitude == '0' || item.longitude == '0' ? (
                    <Button
                      justIcon
                      round
                      simple
                      color={props.themeContext.buttonColorWarning}
                      size="sm"
                      onClick={() => {
                        setShowModalAddress(true);
                        setObjAddress(item);
                      }}
                    >
                      <Edit />
                    </Button>
                  ) : undefined}

                  {(item.latitude != '0' || item.longitude != '0') && true !== undefined && (
                    <Button
                      justIcon
                      round
                      simple
                      color="info"
                      size="sm"
                      onClick={() => {
                        setOpenInfo(true);
                        setInfoData(item);
                        eventClose();
                      }}
                    >
                      <Map />
                    </Button>
                  )}
                </div>
              ),
              CardCode: item.CardCode,
              CardName: item.CardName,
              Address2: item.Address2,
              billAddress: item.billAddress || 'No encontrado',
              stateImg: (
                <img
                  height={32}
                  src={
                    item.state === 'A' && item.frozenFor === 'N'
                      ? '/img/GoogleMarker.png'
                      : '/img/marker_gray.png'
                  }
                />
              ),
              state: item.state === 'A' && item.frozenFor === 'N' ? 'Activo' : 'Inactivo',
              latitude: item.latitude,
              longitude: item.longitude,
              actions: '',
            };
          })}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={eventClose} color="danger" size="sm">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WithApp(DialogDirecciones);
